import {UnifonTheme} from '@phonectas/unifon-ui-kit';
import sc from 'styled-components';


interface StyledSectionDivProps {
  $flex?: boolean;
  $noPadding?: boolean;
  $endDiv?: boolean;
  $fullHeight?: boolean;
  $noBg?: boolean;
  $isSmall?: boolean;
  theme: UnifonTheme;
  $direction?: string;
}

export const StyledSectionDiv = sc.div<StyledSectionDivProps>`
  box-sizing: border-box;
  width: 100%;
  flex-direction: ${({$direction}) => $direction || undefined};
  display: ${({$flex}) => $flex ? 'flex' : 'block'};
  padding: ${({$noPadding}) => $noPadding ? 0 : 16}px;
  border-radius: ${({theme, $endDiv}) => {
		const radius = theme.borderRadius * 2;
		return $endDiv ? `${radius}px ${radius}px 0 0` : `${radius}px`;
	}};
  height: ${({$fullHeight}) => $fullHeight ? '100%' : 'auto'};
  background-color: ${({theme, $noBg}) => {
		return $noBg ? 'none' : theme.palette.white;
	}};
  @media (max-width: 1600px) {
    border-radius: ${({theme, $endDiv, $isSmall}) => {
		const radius = theme.borderRadius * 2;
		return $endDiv && $isSmall ? `${radius}px` : undefined;
	}};
  }
`;

export const StyledSectionTableDiv = sc.div<StyledSectionDivProps>`
  box-sizing: border-box;
  width: 100%;
  height: ${({$fullHeight}) => $fullHeight ? '100%' : 'auto'};
  flex-direction: ${({$direction}) => $direction || undefined};
  display: ${({$flex}) => $flex ? 'flex' : 'block'};
  padding: ${({$noPadding}) => $noPadding ? '16 0' : 16}px;
  border-radius: ${({theme, $endDiv}) => {
		const radius = theme.borderRadius * 2;
		return $endDiv ? `${radius}px ${radius}px 0 0` : `${radius}px`;
	}};
    background-color: ${({theme, $noBg}) => {
		return $noBg ? 'none' : theme.palette.white;
	}};
    @media (max-width: 1600px) {
      border-radius: ${({theme, $endDiv, $isSmall}) => {
		const radius = theme.borderRadius * 2;
		return $endDiv && $isSmall ? `${radius}px` : undefined;
	}};
  }
`;